export default "__VITE_ASSET__VMhkKE_T__"